import { useEffect, useState } from "react"
import Input from "../../../components/Input"
import Popup from "../../../components/Popup"
import { authAxios } from "../../../helpers/axios"
import { IoAddCircle, IoRemoveCircle } from "react-icons/io5"

export default function AddProductVersion({submitLoading,onClose,id,onSubmit})
{
    const [manageData,setManageData] = useState({boms:[], commonBoms:[]})
    const [showCrop,setShowCrop] = useState(false)
    const formName = 'editProductVersion';

    useEffect(() => {
        async function fetchProductData() {
            try {
                let res = await authAxios.get(`${process.env.REACT_APP_BASE_URL}/product/${id}?populate=false`);
                const productData = res.data;
                setManageData({
                    boms: productData.bom.map(bom => ({...bom})),
                    commonBoms: productData.productCommonBoms.map(commonBom => ({...commonBom}))
                });
            } catch (error) {
                console.log(error);
            }
        }
        fetchProductData();
    }, [id]);
    const addBom = () => {
        setManageData((prev) => {
          let prevData = { ...prev, boms: [...prev.boms] };
          prevData.boms.push({ name: '', quantity: '',shared:false });
          return prevData;
        });
      };
      
      const removeBom = (index) => {
        setManageData((prev) => {
          let prevData = { ...prev, boms: [...prev.boms] };
          prevData.boms.splice(index, 1); // Remove item at specific index
          return prevData;
        });
      };
      
      const addCommonBom = () => {
        setManageData((prev) => {
          let prevData = { ...prev, commonBoms: [...prev.commonBoms] };
          prevData.commonBoms.push({ name: '', quantity: '',shared:false });
          return prevData;
        });
      };


      const removeCommonBom = (index) => {
        setManageData((prev) => {
          let prevData = { ...prev, commonBoms: [...prev.commonBoms] };
          prevData.commonBoms.splice(index, 1); // Remove item at specific index
          return prevData;
        });
      };


    const setItem = (type,index,value)=>
    {
        setManageData((prev)=>
        {
        let newData = {...prev}

        if(type === 'name') newData.boms[index].name = value
        if(type === 'quantity') newData.boms[index].quantity = value
        if(type === 'shared') newData.boms[index].shared = value
        if(type === 'rate') newData.boms[index].rate = value

        return newData;
        })

    }

    const setCommonBomItem = (type,index,value)=>
    {
        setManageData((prev)=>
        {
            let newData = {...prev}
            if(type === 'quantity') newData.commonBoms[index].quantity = value
            if(type === 'shared') newData.commonBoms[index].shared = value
            if(type === 'commonBomId') newData.commonBoms[index].commonBomId = value
            return newData
        })
    }

    return <><Popup title='Create Product Version' submitTitle='Create' submitting={submitLoading} onClose={onClose} formName={formName}>
        <form onSubmit={(e)=>onSubmit(e,id,{...manageData})} id={formName} className='w-full'>
            <div className="block grid-cols-2 gap-x-3 gap-y-0 w-full">
            <div className="mb-8">
                <div className="flex justify-between">
                    <p className="mb-4 font-medium text-sm">Product Bill Of Materials</p>
                    <button onClick={()=>addBom()} type="button" className="text-sm text-black font-medium"><IoAddCircle fontSize={24} color="black"/></button>
                </div>
                <div className="grid grid-cols-8 w-full mr-10 mb-2 overflow-hidden">
                    <div className="col-span-3">
                        <p className="text-[11px] uppercase text-gray-400 font-semibold">Material Name</p>
                    </div>
                    <div className="col-span-2">
                        <p className="text-[11px] uppercase text-gray-400 font-semibold">Shared With</p>
                    </div>
                    <div className="col-span-1">
                        <p className="text-[11px] uppercase text-gray-400 font-semibold">Qty.</p>
                    </div>
                    <div className="col-span-1">    
                        <p className="text-[11px] uppercase text-gray-400 font-semibold">Rate</p>
                    </div>
                    <div className="col-span-1">    
                        <p className="text-[11px] uppercase text-gray-400 font-semibold">Stock</p>
                    </div>
                </div>
                {
                    manageData.boms.map((item,index)=>
                {
                    return <BomItem item={item} removeBom={removeBom} addBom={addBom} setItem={setItem} key={index} index={index} length={manageData.boms.length}/>
                })
                }
            </div>

            <div className="border-t border-t-gray-200 pt-6 my-4">
                <div className="flex justify-between">
                    <p className="mb-4 font-medium text-sm">Common Product Bill Of Materials</p>
                    <button onClick={()=>addCommonBom()} type="button" className="text-sm text-black font-medium"><IoAddCircle fontSize={24} color="black"/></button>
                </div>
                {
                    manageData.commonBoms.map((item,index)=>
                {
                    return <CommonBomItem item={item} removeBom={removeCommonBom} addBom={addCommonBom} setItem={setCommonBomItem} key={index} index={index} length={manageData.commonBoms.length}/>
                })
                }
            </div>
            </div>
        </form>
    </Popup>
    </>
}


const CommonBomItem = ({item,setItem,index,length,addBom,removeBom})=>
{
    const [commonBoms,setCommonBoms] = useState([])

    async function getCommonBoms(){
        let res = await authAxios.get(`${process.env.REACT_APP_BASE_URL}/common-bom?populate=true&limit=100`)
        setCommonBoms(res.data.rows)
    }

    const getSelectedCommonBom = ()=>{
        let selectedCommonBom = commonBoms.find(it=>it.id === item.commonBomId)
        return selectedCommonBom
    }
    useEffect(()=>{
        getCommonBoms()
    },[])
    
    useEffect(()=>{
        getSelectedCommonBom()
    },[item.commonBomId])
    
    return <div className="flex items-center relative mb-4">
        <div className="grid grid-cols-7 w-full mr-10 border border-gray-200 bg-[#fcfcfc] rounded-[4px] overflow-hidden">
            <div className="col-span-3">
                <select required className="w-full py-2 px-4 text-[13px] font-medium focus:shadow-none focus:ring-0 border-0 border-r border-r-gray-200 rounded-none" value={item.commonBomId} onChange={(e)=>setItem('commonBomId',index,e.target.value)}>
                    <option value={null}>Select Common BOM</option>
                    {commonBoms.map((item,index)=>
                        <option value={item.id}>{item.name}</option>
                    )}
                </select>
            </div>
            <div className="col-span-2">
                <select required className="w-full py-2 px-4 text-[13px] font-medium focus:shadow-none focus:ring-0 border-0 border-r border-r-gray-200 rounded-none" value={item.shared} onChange={(e)=>setItem('shared',index,e.target.value)}>
                    <option value={0}>Need Qty of</option>
                    <option value={1}>Shared With</option>
                    <option value={2}>Shared weight</option>
                    </select>
            </div>
            <div className="col-span-1 border-r border-r-gray-200">
                <input type="text" placeholder="Qty." className="w-full py-2 px-4 text-[13px] font-medium" value={item.quantity} onChange={(e)=>setItem('quantity',index,e.target.value)}/>
            </div>
            <div className="col-span-1 border-r border-r-gray-200">
                <input required disabled type="text" placeholder="Qty." className="w-full py-2 px-4 text-[13px] font-medium" value={item.commonBomId ? item.quantity * (getSelectedCommonBom() ? getSelectedCommonBom().rate : 0) : 0}/>
            </div>
        </div>
        <div className="ml-2 absolute right-0"><button type="button" onClick={()=>removeBom(index)}><IoRemoveCircle color="red" fontSize={32}/></button></div>
    </div>
}

const BomItem = ({item,setItem,index,length,addBom,removeBom})=>
    {
        return <div className="flex items-center relative mb-4">
            <div className="grid grid-cols-8 w-full mr-10 border border-gray-200 bg-[#fcfcfc] rounded-[4px] overflow-hidden">
                <div className="col-span-3">
                    <input type="text" placeholder="Material Name" className="w-full py-2 px-4 text-[13px] font-medium border-r border-r-gray-300" value={item.name} onChange={(e)=>setItem('name',index,e.target.value)}/>
                </div>
                <div className="col-span-2">
                    <select className="w-full py-2 px-4 text-[13px] font-medium focus:shadow-none focus:ring-0 border-0 border-r border-r-gray-200 rounded-none" value={item.shared} onChange={(e)=>setItem('shared',index,e.target.value)}>
                        <option value={0}>Need Qty of</option>
                        <option value={1}>Shared With</option>
                        <option value={2}>Shared weight</option>
                        </select>
                </div>
                <div className="col-span-1 border-r border-r-gray-200">
                    <input type="text" placeholder="Qty." className="w-full py-2 px-4 text-[13px] font-medium" value={item.quantity} onChange={(e)=>setItem('quantity',index,e.target.value)}/>
                </div>
                <div className="col-span-1 border-r border-r-gray-200">
                    <input type="decimal" placeholder="Rate" className="w-full py-2 px-4 text-[13px] font-medium" value={item.rate} onChange={(e)=>setItem('rate',index,e.target.value)}/>
                </div>
                <div className="col-span-1">
                    <input type="decimal" placeholder="Stock" className="w-full py-2 px-4 text-[13px] font-medium" value={item.stock} onChange={(e)=>setItem('stock',index,e.target.value)}/>
                </div>
            </div>
            <div className="ml-2 absolute right-0"><button type="button" onClick={()=>removeBom(index)}><IoRemoveCircle color="red" fontSize={32}/></button></div>
        </div>
    }